import type { CSSProperties, ReactNode } from "react";
import { tokens } from "../tokens";

interface LabelProps {
	children: ReactNode;
	// Emphasis of the label against the ground; picks a step of the text ladder.
	tone?: "secondary" | "muted" | "primary";
	as?: "span" | "div" | "label";
	htmlFor?: string;
	style?: CSSProperties;
}

const toneColor = {
	secondary: tokens.color.text.secondary,
	muted: tokens.color.text.muted,
	primary: tokens.color.text.primary,
} as const;

// The label voice: wide tracked uppercase micro caps. The child string stays lower case in source;
// the uppercase is a render transform, so it stays readable and translatable.
export function Label({ children, tone = "secondary", as = "span", htmlFor, style }: LabelProps) {
	const Tag = as;
	return (
		<Tag
			htmlFor={as === "label" ? htmlFor : undefined}
			style={{ ...tokens.type.microcap, color: toneColor[tone], ...style }}
		>
			{children}
		</Tag>
	);
}
